import axios from 'axios';

const TOKEN_KEY = 'carbi_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const saveToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60000,
});

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      clearToken();
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export const apiErrorMessage = (err, fallback) =>
  err?.response?.data?.detail || (err?.code === 'ECONNABORTED' ? 'La solicitud tardó demasiado. Intenta de nuevo.' : fallback);

export async function login(password) {
  const { data } = await client.post('/auth/login', { password });
  return data.token;
}

export async function transcribe(blob, mimeType) {
  const ext = mimeType.includes('mp4') ? 'mp4' : mimeType.includes('wav') ? 'wav' : 'webm';
  const form = new FormData();
  form.append('file', blob, `grabacion.${ext}`);
  const { data } = await client.post('/transcribe', form);
  return data.text;
}

export async function chat(history, text) {
  const { data } = await client.post('/chat', { history, text });
  return data;
}
